let productsLoaded = false;

function toggleCategories(event) {
  event.preventDefault();

  // Seleciona o botão clicado com base no evento
  const categoryButton = event.currentTarget;

  // Encontra o submenu relacionado ao botão clicado
  const categoryMenu = categoryButton.nextElementSibling;

  // Verifica se o menu está expandido
  const isExpanded = categoryButton.getAttribute("aria-expanded") === "true";

  // Alterna o estado do atributo 'aria-expanded'
  categoryButton.setAttribute("aria-expanded", !isExpanded);

  // Exibe ou oculta o submenu
  isExpanded ? $(categoryMenu).slideUp(100) : $(categoryMenu).slideDown(100);

  // Controla a exibição dos ícones relacionados ao botão clicado
  const iconArrowDown = categoryButton.querySelector("#icon-arrow-down");
  const iconArrowUp = categoryButton.querySelector("#icon-arrow-up");

  if (!isExpanded) {
    iconArrowDown.style.display = "none"; // Oculta o ícone de "arrow-down"
    iconArrowUp.classList.remove("hidden"); // Exibe o ícone de "arrow-up"
  } else {
    iconArrowDown.style.display = "block"; // Exibe o ícone de "arrow-down"
    iconArrowUp.classList.add("hidden"); // Oculta o ícone de "arrow-up"
  }

  // Verifica se é o menu "Top 10" e carrega os produtos
  if (categoryButton.id === "HeaderDrawer-products" && !productsLoaded) {
    fetchTopProducts();
    productsLoaded = true; // Marca como carregado para não fazer mais requisições
  }
}

